import { render, staticRenderFns } from "./landing.template.vue?vue&type=template&id=3f7c0fba&scoped=true&"
var script = {}
import style0 from "./landing.template.vue?vue&type=style&index=0&id=3f7c0fba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7c0fba",
  null
  
)

export default component.exports